import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import "react-notifications-component/dist/theme.css";

const App = () => {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
};

export default App;
